import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import newLogo from "./solid-step-logo.png";
  
const LOGO_URL = newLogo;

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div>
            <img src={LOGO_URL} alt="Solid Step" className="h-24 w-auto mb-6" />
            <p className="text-[#A3A3A3] text-sm leading-relaxed">
              From Floor to Finish — We've Got You Covered. Premium flooring and handyman solutions for residential and commercial spaces across Australia.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.instagram.com/golden_touch.c0?igsh=MWNod3JsN29haTBicg=="
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-[#A3A3A3] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-all"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://www.facebook.com/share/1CbqSD4Wmi/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-[#A3A3A3] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-all"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="https://www.tiktok.com/@golden.touch861?_r=1&_t=ZS-96ZUGG0SzjR"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-tiktok"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-[#A3A3A3] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-all"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.7a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.13z"/></svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-6">Flooring</h4>
            <ul className="space-y-3">
              {[
                { label: "Hybrid Flooring", id: "hybrid-flooring" },
                { label: "Laminate Flooring", id: "laminate-flooring" },
                { label: "Vinyl Flooring", id: "vinyl-flooring" },
                { label: "Timber Flooring", id: "timber-flooring" },
                { label: "Carpet Installation", id: "carpet-installation" },
              ].map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services/${s.id}`}
                    data-testid={`footer-service-${s.id}`}
                    className="text-[#A3A3A3] text-sm hover:text-[#D4AF37] transition-colors"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-6">Handyman</h4>
            <ul className="space-y-3">
              {[
                { label: "Lawn Care", id: "lawn-care" },
                { label: "Outdoor & Exterior", id: "outdoor-exterior" },
                { label: "Door Installation", id: "door-installation" },
                { label: "Demolition", id: "demolition" },
                { label: "Painting", id: "painting" },
                { label: "Fence Installation", id: "fence-installation" },
                { label: "Pressure Washing", id: "pressure-washing" },
                { label: "General Handyman", id: "general-handyman" },
              ].map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services/${s.id}`}
                    data-testid={`footer-service-${s.id}`}
                    className="text-[#A3A3A3] text-sm hover:text-[#D4AF37] transition-colors"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/home" },
                { label: "About Us", path: "/about" },
                { label: "Gallery", path: "/gallery" },
                { label: "Get a Quote", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-[#A3A3A3] text-sm hover:text-[#D4AF37] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                <a href="tel:+61413621730" className="text-[#A3A3A3] text-sm hover:text-[#D4AF37] transition-colors">
                  0413 621 730
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                <a href="mailto:info@solidstep.com.au" className="text-[#A3A3A3] text-sm hover:text-[#D4AF37] transition-colors">
                  info@solidstep.com.au
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#D4AF37] mt-1 flex-shrink-0" />
                <span className="text-[#A3A3A3] text-sm">
                  Servicing Melbourne & Surrounding Areas, VIC
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-line mt-12 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#A3A3A3] text-xs">
            &copy; {new Date().getFullYear()} Solid Step Flooring & Handyman. All rights reserved.
          </p>
          <p className="text-[#A3A3A3] text-xs">
            ABN: 00 000 000 000 | Licensed & Insured
          </p>
        </div>
      </div>
    </footer>
  );
}
